module.exports = __webpack_public_path__ + "img/consulting.2eaf3be3.jpg";